import { Injector }        from '@angular/core';
import { RouteDefinition } from '@core/interfaces/route.interface';
import { AppInjector }     from '@core/services/app-injector.service';
import {
	IRouterActions,
	routerActions
}                          from '@core/store/router/router.actions';
import { routerReducer }   from '@core/store/router/router.reducer';
import { routerSelector }  from '@core/store/router/router.selectors';
import { RouterState }     from '@core/store/router/router.state';
import {
	createEntityAdapter,
	EntityAdapter
}                          from '@ngrx/entity';
import { LoggerService }   from '@shared/services/logger.service';
import { take }            from 'rxjs/operators';

class RouterStore {
	private readonly _storeId = 'router';

	private _initialState: RouterState;

	private _adapter: EntityAdapter<RouteDefinition>;

	private _actions: IRouterActions;

	private _selectors;

	private _reducers;

	private _logger: LoggerService;

	get storeId() { return this._storeId; }

	get initialState() { return this._initialState; }

	get reducers() { return this._reducers; }

	get actions() { return this._actions; }

	get selectors() { return this._selectors; }

	constructor() {
		this.init();

		AppInjector.getInjector$()
		.pipe( take( 1 ) )
		.subscribe( ( injector: Injector ) => {
			this._logger = injector?.get( LoggerService );
			this.init();
		} );
	}

	private init(): void {
		this._adapter = createEntityAdapter<RouteDefinition>( {
			selectId: this.selectRouteDefinitionId,
			sortComparer: false
		} );

		this._initialState = {
			adapter: this._adapter.getInitialState()
		};

		this._actions = routerActions( this._storeId );
		this._reducers = routerReducer( this._storeId, this._initialState, this._adapter, this._logger );
		this._selectors = routerSelector( this._adapter, this._storeId, this._logger );
	}

	private selectRouteDefinitionId( routeDefinition: RouteDefinition ): string {
		// This needs to be covered with empty value because of navigationSucceedHandler()
		// Based on generateFallbackPreviousRouteFromCurrentRouteState() default value is '0'
		return routeDefinition?.id ?? '0';
	}
}

export const routerStore = new RouterStore();

